module.exports = __webpack_public_path__ + "static/media/v-bit_coin.4fb9234c.png";